/* Spanish UI strings. Only the interface is translated — never the data. */
export const es = {
  app: { name: 'ETC Connect', tagline: 'Innovamos para formar futuros brillantes.' },
  common: {
    save: 'Guardar', cancel: 'Cancelar', edit: 'Editar', search: 'Buscar',
    loading: 'Cargando…', back: 'Atrás', close: 'Cerrar', confirm: 'Confirmar',
    all: 'Todos', yes: 'Sí', no: 'No', required: 'Obligatorio',
    readonly: 'Solo lectura', editable: 'Editable', blocked: 'Bloqueado',
    page: 'Página', of: 'de', next: 'Siguiente', prev: 'Anterior',
    complete: 'Completo', incomplete: 'Pendiente', primary: 'Primario',
    active: 'Activo', orphan: 'Desasociado', filter: 'Filtrar',
    view: 'Ver', open: 'Abrir', request: 'Solicitar', submit: 'Enviar',
    upload: 'Cargar', download: 'Descargar', or: 'o',
    signin: 'Iniciar sesión', signout: 'Cerrar sesión',
    username: 'Usuario', password: 'Contraseña', soon: 'Próximamente',
    last_updated: 'Última actualización',
    completeness: '% Progreso',
    missing: 'Faltante',
  },
  nav: {
    dashboard: 'Panel',
    org: 'Mi organización',
    sites: 'Sites',
    instructors: 'Instructores',
    users: 'Usuarios y roles',
    admin: 'Administración',
    orgs: 'Organizaciones',
    reports: 'Reportes',
  },
  login: {
    welcome: 'Bienvenido al portal de asociados',
    sub: 'Learning and Certification partners',
    forgot: '¿Olvidaste tu contraseña?',
    // recovery flow
    forgot_title: 'Recupera tu contraseña',
    forgot_help: 'Ingresa el correo asociado a tu cuenta. Te enviaremos un enlace para restablecer tu contraseña.',
    send_link: 'Enviar enlace',
    sent_title: 'Revisa tu correo',
    // Sin decir cuánto dura: el plazo lo fija el servidor (RESET_TTL_HORAS)
    // y aquí decía «30 minutos» cuando de verdad son dos horas. El correo
    // sí lo dice, porque es quien lo sabe.
    sent_help: 'Si existe una cuenta asociada a {email} recibirás un enlace en unos minutos. El propio correo dice cuánto dura el enlace.',
    sent_resend: 'Reenviar enlace',
    sent_no_email: '¿No lo recibes? Revisa tu carpeta de spam. Si no llega, escribe al equipo de ETC Iberoamérica.',
    back_to_login: 'Volver al inicio de sesión',
    reset_title: 'Crear nueva contraseña',
    reset_help: 'Elige una contraseña fuerte. Mínimo 12 caracteres, una mayúscula y un número.',
    new_password: 'Nueva contraseña',
    confirm_password: 'Confirmar contraseña',
    password_mismatch: 'Las contraseñas no coinciden.',
    password_weak: 'Mínimo 8 caracteres, una mayúscula y un número.',
    reset_success: 'Contraseña actualizada. Ya puedes iniciar sesión.',
    pw_show: 'Mostrar',
    pw_hide: 'Ocultar',
    pw_strength: 'Fortaleza',
    pw_strength_weak: 'Débil',
    pw_strength_med: 'Media',
    pw_strength_strong: 'Fuerte',
  },
  roles: {
    ETC_ADMIN: 'Admin ETC',
    PARTNER_MGR: 'Gerente / Admin del socio',
    SITE_MGR: 'Site Manager',
    SITE_ADMIN: 'Site Admin',
    ATC_DIR: 'ATC Director',
    INSTRUCTOR: 'Instructor',
  },
  window: {
    open_banner: 'Proceso de actualización abierto · Cierra el {date}',
    closed_banner: 'Proceso de actualización cerrado · Modo solo lectura. Próximo proceso: {date}',
    // El proceso es un mecanismo para los socios; el Admin ETC está exento a
    // propósito, porque es quien tiene que poder arreglar cosas todo el año.
    // Decirle «modo solo lectura» era falso, y encima contradecía a los
    // botones de editar, que a él sí le funcionan.
    closed_banner_admin: 'Proceso de actualización cerrado para los socios · Tú puedes editar. Próximo proceso: {date}',
    // Al Site Manager la franja le prometía que en el próximo proceso podría
    // editar. No podrá nunca: su rol es de solo consulta.
    readonly_role: 'Tu cuenta es de solo consulta',
    admin_open: 'Abrir proceso',
    admin_close: 'Cerrar proceso',
    status_open: 'Abierta',
    status_closed: 'Cerrada',
  },
  kpi: {
    orgs: 'Organizaciones',
    sites: 'Sites',
    active_instr: 'Instructores activos',
    orphans: 'Desasociados',
    red_pending: 'Fichas con rojos pendientes',
    completeness: '% Progreso',
  },
  field: {
    state_editable: 'Editable',
    state_readonly: 'Solo lectura',
    state_required: 'Obligatorio',
    state_blocked: 'Bloqueado',
    state_tip_edit: 'El socio puede modificar este campo.',
    state_tip_read: 'Visible pero no editable.',
    state_tip_req: 'Obligatorio. Cuenta para tu porcentaje del proceso de actualización.',
    state_tip_lock: 'Referencia del sistema o derivado. No editable.',
    legend: 'Leyenda de campos',
    required_empty: 'Este campo es obligatorio',
    otro_sin_texto: 'Marcaste «Otro»: escribe cuál',
    codigo_invalido: 'Valor no reconocido; usa uno de la lista',
    postal_invalid: 'Código postal no válido (no se admite vacío ni "0000")',
    email_invalid: 'Email no válido',
    phone_invalid: 'Teléfono no válido (incluye código de país)',
  },
  sec: {
    general: 'Generales',
    registered_address: 'Dirección registrada',
    contract_address: 'Contractual',
    billing_address: 'Facturación',
    billing_contact: 'Contacto de facturación',
    legal_contact: 'Contacto legal',
    atc_director: 'ATC Director',
    site_admin: 'Site Admin',
    site_manager: 'Site Manager',
    identifiers: 'Identificadores',
    site_data: 'Datos del site',
    assignments: 'Afiliado a:',
    personal: 'Datos personales',
    perfil: 'Perfil del socio',
  },
  legal: {
    request_change: 'Solicitar cambio de contacto legal',
    readonly_note: 'El contacto legal es solo lectura para todos los roles del socio. Solicita cambio adjuntando documento oficial de nombramiento.',
    status_pending: 'Cambio solicitado · en revisión por ETC',
    request_title: 'Solicitar cambio de contacto legal',
    request_help: 'Adjunta documento oficial de nombramiento (PDF). El equipo ETC revisará la solicitud.',
    attach_doc: 'Adjuntar documento',
    new_first: 'Nuevo nombre',
    new_last: 'Nuevo apellido',
    new_email: 'Nuevo email',
    new_phone: 'Nuevo teléfono',
    sent: 'Solicitud enviada a ETC',
  },
  admin: {
    title: 'Administración ETC',
    window: 'Proceso de actualización',
    window_help: 'Habilita la edición para todos los socios durante un periodo definido.',
    deadline: 'Fecha límite',
    requests: 'Solicitudes de cambio de contacto legal',
    approve: 'Aprobar', reject: 'Rechazar',
    import: 'Importar desde Excel',
    import_help: 'Carga un archivo .xlsx con organizaciones, sites, instructores o afiliaciones. Se previsualiza antes de aplicar.',
    choose_file: 'Seleccionar archivo',
    target_entity: 'Entidad destino',
    rows_valid: 'Filas válidas',
    rows_errors: 'Filas con error',
    map_columns: 'Mapeo de columnas',
    apply: 'Aplicar al sistema',
    orphans: 'Instructores desasociados',
    orphans_help: 'Instructores sin afiliación activa a ningún site. Pueden desactivarse.',
    deactivate: 'Desactivar',
  },
  sites: {
    title: 'Sites',
    primary_label: 'Site primario',
    primary_tip: 'El site primario no puede desasignarse sin reasignar otro.',
    change_primary: 'Cambiar site primario',
  },
  instr: {
    title: 'Instructores',
    filter_all: 'Todos',
    filter_active: 'Activos',
    filter_orphan: 'Desasociados',
    filter_by_site: 'Por site',
  },
  users: {
    title: 'Usuarios y roles',
    matrix: 'Matriz de permisos',
    scope: 'Alcance',
    can_edit: 'Puede editar',
    cannot: 'No puede',
  },
  chpw: {
    title: 'Elige tu contraseña',
    intro: 'Hola {name}. Entraste con una contraseña temporal, así que hay que cambiarla antes de continuar.',
    current: 'Contraseña temporal',
    next: 'Contraseña nueva',
    repeat: 'Repite la contraseña nueva',
    too_short: 'Debe tener al menos 12 caracteres.',
    mismatch: 'Las dos contraseñas no coinciden.',
    submit: 'Guardar y entrar',
    saving: 'Guardando…',
    signout: 'Cerrar sesión',
    weak_hint: 'Es larga, pero mezclar mayúsculas y números la hace bastante más difícil de adivinar.',
  },
  fallo: {
    titulo: 'Esta pantalla no se pudo mostrar',
    texto: 'No se ha perdido nada de lo que ya estaba guardado. Recarga la página para seguir.',
    traductor: 'Si el navegador está traduciendo la página, desactiva la traducción: ETC Connect ya está en español y en inglés (selector ES / EN, arriba a la derecha).',
    recargar: 'Recargar la página',
  },
} as const;
